/* eslint-disable import/order */
import React from 'react';
import { arrayOf, bool, shape } from 'prop-types';

// components
import SelectorSkeleton from './SelectorSkeleton';
import Selector from '../selector/Selector.connector';
import SelectorVirtualizer from '../../../selectors-list/SelectorVirtualizer';
import SelectorsList from '../../../selectors-list/SelectorsList';

// styles
import { selectorsListStyles } from './SelectorsList.styles';
import { useTheme } from '@mui/material/styles';

const SelectorsListSection = props => {
  const { selectorsList, selectorsListLoading } = props;
  const SELECTOR_SKELETON_HEIGHT = 121; // actual height of the rendered selector container
  const theme = useTheme();

  return (
    <SelectorsList
      loading={selectorsListLoading}
      selector={
        <SelectorVirtualizer
          itemSize={() => 120}
          overscanCount={10}
          selectorComponent={Selector}
          selectorsData={selectorsList}
        />
      }
      skeletonComponent={<SelectorSkeleton skeletonHeight={SELECTOR_SKELETON_HEIGHT} />}
      skeletonHeight={SELECTOR_SKELETON_HEIGHT}
      sx={{ ...selectorsListStyles(theme) }}
    />
  );
};

SelectorsListSection.propTypes = {
  selectorsList: arrayOf(shape({})).isRequired,
  selectorsListLoading: bool.isRequired,
};

export default SelectorsListSection;
